export enum TileType {
  Floor = 0,
  Wall = 1
}

export enum ActionType {
  Move = 'move',
  Attack = 'attack',
  Special = 'special',
  Wait = 'wait'
}

export enum Allegiance {
  Player = 'player',
  Enemy = 'enemy'
}

// Define the types of control for units
export enum ControlType {
  Manual = 'manual',   // Requires player input
  Automatic = 'auto'   // Acts automatically regardless of allegiance
}

// Unit class types
export enum UnitClass {
  Warrior = "Warrior",   // Melee-focused, aggressive (Merk)
  Archer = "Archer",     // Ranged attacks, maintains distance
  Mage = "Mage",         // Area effect abilities, vulnerable
  Scout = "Scout",       // Fast movement, exploration (Imp)
  Rogue = "Rogue",       // Moves diagonally, backstabs
  Dog = "Dog"            // Stays near allies, bark pushes enemies
}